export default __webpack_public_path__ + "static/media/gy.a21e185b.jpg";